<template>
  <section>
    <div v-if="loading">
      <!-- CALENDAR -->

      <div
        v-if="!start_ia"
        class="flex bg-theme-1 p-2 rounded mb-4 cursor-pointer w-10 justify-center hidden"
        @click="IAreport()"
      >
        <app-icon name="rocket" class="w-5 h-5 text-white"></app-icon>
      </div>
      <div
        class="flex bg-theme-1 p-2 rounded gap-2 mb-4 cursor-pointer w-full"
        v-else
      >
        <app-icon
          name="rocket"
          class="w-5 h-5 text-white"
          v-if="icon_ia"
        ></app-icon>
        <div
          class="text-white w-full"
          v-if="message"
          v-html="simpleMarkdownToHTML(message)"
        ></div>
      </div>

      <app-kalendar
        :configuration="calendar_settings"
        :events.sync="calendars"
        @click="handleEventClick"
        v-if="loadCalendar"
      >
        <!-- CREATED CARD SLOT -->
        <div
          slot="created-card"
          slot-scope="{ event_information }"
          class="details-card cursor-pointer"
          @click="handleEventClick(event_information)"
        >
          <h4 class="appointment-description">
            {{ event_information.data.title }}
          </h4>
          <span class="time"
            >{{ event_information.start_time | formatToHours }} -
            {{ event_information.end_time | formatToHours }}</span
          >
          <button
            v-if="id == user.slug"
            @click="removeEventKalendar(event_information)"
            class="remove"
          >
            <app-icon name="trash" class="text-white w-4 h-4"></app-icon>
          </button>
        </div>
        <!-- CREATING CARD SLOT -->
        <div slot="creating-card" slot-scope="{ event_information }">
          <h4 class="appointment-title" style="text-align: left">
            Nuevo Evento
          </h4>
          <span class="time">
            {{ event_information.start_time | formatToHours }} -
            {{ event_information.end_time | formatToHours }}
          </span>
        </div>
        <!-- POPUP CARD SLOT -->
        <div
          slot="popup-form"
          slot-scope="{ popup_information }"
          style="display: flex; flex-direction: column"
        >
          <h4 style="margin-bottom: 10px">Nuevo Evento</h4>
          <form @submit.prevent="addEvent(popup_information)">
            <textarea
              v-model="new_appointment['description']"
              type="text"
              placeholder="Titulo"
              rows="2"
              required
            ></textarea>
            <div class="buttons">
              <button class="cancel" @click="closePopups()">Cancelar</button>
              <button type="submit" :disabled="buttonIsLoading">Guardar</button>
            </div>
          </form>
        </div>
      </app-kalendar>
      <!-- END: CALENDAR -->

      <div
        class="fixed bg-white w-56 bottom-0 left-0 h-40 p-2 rounded"
        v-if="event_current"
      >
        <div
          class="flex flex-col justify-center items-center border border-theme-1 p-2 h-32 mt-2"
        >
          <p class="text-theme-1 mb-2">
            {{ event_current.data.title | limit100 }}
          </p>
          <div class="flex gap-3">
            <button
              type="button"
              class="border border-theme-1 text-theme-1 rounded py-1 px-2 text-xs"
              @click="event_current = null"
            >
              Cancelar
            </button>
            <button
              v-if="id == user.slug"
              type="button"
              class="bg-theme-1 text-white rounded py-1 px-2 text-xs"
              @click="removeEventList(event_current.data)"
            >
              Eliminar
            </button>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <h2 class="mb-2 font-bold text-lg">
          Lista de Eventos ({{ filteredCalendars.length }})
        </h2>
        <div class="mb-4 inline-flex gap-2">
          <div class="py-2">Filtrar por fecha:</div>
          <input
            type="date"
            v-model="filter.date"
            class="input w-56 border flex-1"
          />
          <div
            class="bg-theme-1 p-2 rounded w-10 h-10 cursor-pointer hover:bg-theme-6"
            v-if="filter.date"
            @click="filter.date = null"
          >
            <app-icon name="trash" class="text-white w-4 h-4"></app-icon>
          </div>
        </div>
        <div
          v-for="(calendar, index) in filteredCalendars"
          class="bg-white p-2 rounded mb-2 flex px-5"
          :key="calendar.id"
        >
          <div class="w-2/6" v-if="editIndex === index">
            <input
              type="text"
              v-model="current_calendar.title"
              required
              :class="`input w-full border mt-2 flex-1`"
            />
          </div>
          <div class="w-2/6" v-else>{{ calendar.title }}</div>
          <div class="w-1/4">{{ calendar.from.substr(0, 10) }}</div>
          <div class="w-1/4">{{ calendar.from | formatToHours }}</div>
          <div class="w-1/4">{{ calendar.to | formatToHours }}</div>
          <div class="w-1/4 text-center">
            <button
              v-if="editIndex === index"
              @click="updateItem()"
              class="bg-green-400 text-white rounded py-1 px-2 text-xs"
            >
              Guardar
            </button>
            <button
              v-else
              @click="editItem(index, calendar)"
              type="button"
              class="bg-theme-1 text-white rounded py-1 px-2 text-xs"
            >
              Editar
            </button>
            <button
              v-if="id == user.slug"
              type="button"
              class="bg-red-600 text-white rounded py-1 px-2 text-xs"
              @click="removeEventList(calendar)"
            >
              Eliminar
            </button>
          </div>
        </div>
      </div>

      <h2
        class="font-medium mr-auto fixed bottom-0 bg-theme-1 text-white border-1 border-white py-2 px-4 rounded-t-lg z-10"
      >
        Calendario <span v-if="user_calendar"> - {{ user_calendar.name }}</span>
      </h2>
    </div>

    <div v-else>
      <app-loading></app-loading>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Loading from '@/components/admin/partials/LoadingWhite'

import Vue from 'vue'
import PortalVue from 'portal-vue'
Vue.use(PortalVue)
import { Kalendar } from 'kalendar-vue'
import { DateTime } from 'luxon'

export default {
  name: 'AdminCalendarUser',
  data() {
    return {
      loading: false,
      id: this.$route.params.id,
      calendar_settings: {
        view_type: 'week',
        style: 'material_design',
        cell_height: 10,
        scrollToNow: true,
        military_time: false,
        read_only: false,
        day_starts_at: 7,
        day_ends_at: 22,
        overlap: true,
        hide_dates: [],
        hide_days: [5, 6],
        past_event_creation: true,
      },
      new_appointment: this.clearPopupCreate(),
      popup_information: {},
      renderComponent: true,
      user_calendar: null,
      calendars: [],
      buttonIsLoading: false,
      loadCalendar: false,
      event_current: null,
      filter: {
        date: null,
      },
      editIndex: null,
      current_calendar: {
        title: '',
        id: '',
        entity: 'calendar',
        from: '',
      },
      message: null,
      start_ia: false,
      icon_ia: true,
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
    }),
    filteredCalendars() {
      return this.calendars.filter((item) => {
        let date = this.filter.date
          ? this.filter.date == item.from.substr(0, 10)
          : true
        return date
      })
    },
  },
  created() {
    Vue.filter('formatToHours', (value, how) => {
      let dt = DateTime.fromISO(value)
      return dt.toLocaleString(DateTime.TIME_24_SIMPLE)
    })
  },
  async beforeMount() {
    try {
      await this.getUser()
      await this.getCalendars()
    } catch (error) {
    } finally {
      this.loading = true
    }
  },
  watch: {
    calendar_settings: {
      handler(newValue) {
        this.kalendarKey = new Date().valueOf()
      },
      deep: true,
    },
  },
  methods: {
    clearPopupCreate() {
      return {
        title: null,
        description: null,
      }
    },
    async getCalendars() {
      this.loading = false
      try {
        const { list } = await this.getListCalendarsMongo(
          `/calendar/list?user_id=${this.user_calendar.id}`
        )

        const formattedList = list.map((item) => {
          return {
            ...item,
            data: {
              title: item.title,
              description: item.description,
              user_id: item.user_id,
              id: item.id,
            },
          }
        })
        //console.log(formattedList)
        this.calendars = formattedList
        //console.log(list.length)
        this.loading = true
        this.loadCalendar = true
      } catch (error) {
        console.log(error)
        this.loading = true
      } finally {
        this.loading = true
      }
    },
    addEvent(popup_data, form_data) {
      this.buttonIsLoading = true
      var vm = this
      vm.loading = false
      let payload = {
        title: vm.new_appointment.description,
        description: vm.new_appointment.description,
        description: '-',
        from: popup_data.start_time,
        to: popup_data.end_time,
        user_id: this.user_calendar.id,
        entity: 'calendar',
      }
      vm.store(payload)
        .then((item) => {
          location.reload()
        })
        .catch((error) => {
          const errors =
            error.response && error.response.data
              ? error.response.data.errors
              : []

          Object.entries(errors).forEach(([field, messages]) => {
            console.log(`Campo: ${field}`)
            if (Array.isArray(messages)) {
              messages.forEach((msg) => window.$toast.error(msg))
            } else {
              window.$toast.error(messages)
            }
          })
          vm.loading = true
        })
        .finally(() => {
          vm.loading = true
        })
    },
    editItem(index, item) {
      console.log(item)
      this.editIndex = index
      this.current_calendar.title = item.title
      this.current_calendar.id = item.id
      this.current_calendar.from = item.from
    },
    updateItem() {
      var vm = this
      vm.loading = false
      console.log(vm.current_calendar)

      vm.put(vm.current_calendar)
        .then((item) => {
          location.reload()
        })
        .catch((message) => {
          vm.loading = true
        })
        .finally(() => {
          vm.loading = true
        })
    },
    removeEvent(id) {
      var vm = this
      vm.loading = false
      vm.form = {
        id: id,
        entity: 'calendar',
      }
      console.log(vm.form)
      vm.remove(vm.form)
        .then((item) => {
          location.reload()
        })
        .catch((message) => {
          vm.loading = true
        })
        .finally(() => {
          vm.loading = true
        })
    },
    removeEventKalendar(kalendarEvent) {
      this.removeEvent(kalendarEvent.kalendar_id)
    },
    removeEventList(calendar) {
      //console.log(calendar)
      this.removeEvent(calendar.id)
    },
    handleEventClick(event) {
      this.event_current = event
    },
    closePopups() {
      this.$kalendar.closePopups()
    },
    async getUser() {
      this.loading = false
      try {
        const { model } = await this.get(`/user-slug/${this.$route.params.id}`)
        this.user_calendar = model
        this.loading = true
      } catch (error) {
        console.log(error)
        this.loading = true
      } finally {
        this.loading = true
      }
    },
    async IAreport() {
      this.start_ia = true
      this.message = 'Analizando los eventos...'
      try {
        const body = {
          entity: 'calendar-ai',
          user_id: this.user_calendar.id,
        }
        const { response } = await this.post(body)
        this.message = response
        this.icon_ia = false
        this.loading = true
      } catch (error) {
        console.log(error)
        this.loading = true
      } finally {
        this.loading = true
      }
    },
    simpleMarkdownToHTML(text) {
      let hasTable = false
      return (
        text
          // Tablas
          .replace(/(\|.*\|\n*)+/gm, (match) => {
            hasTable = true
            const rows = match
              .split('\n')
              .filter((row) => row.trim())
              .map((row) => {
                const cells = row
                  .split('|')
                  .filter((cell) => cell.trim())
                  .map((cell) => cell.trim())

                // Ignorar la fila separadora
                if (cells.some((cell) => cell.includes('---'))) {
                  return ''
                }

                const cellsHtml = cells
                  .map(
                    (cell) =>
                      `<td class="border p-2 text-sm whitespace-normal w-1/3">${cell}</td>`
                  )
                  .join('')

                return `<tr class="border-b hover:bg-gray-50">${cellsHtml}</tr>`
              })
              .filter((row) => row)

            return `
                <table class="w-full">
                  ${rows.join('')}
                </table>`
          })
      )
    },
    ...mapActions([
      'get',
      'getListCalendarsMongo',
      'put',
      'post',
      'getList',
      'store',
      'remove',
    ]),
  },
  components: {
    appIcon: Icon,
    appLoading: Loading,
    appKalendar: Kalendar,
  },
}
</script>

<style lang="scss">
$green: #00f0b5;
$red: #f61067;
$blue: #007fff;
$yellow: #f5d547;
$dark: #3c3c3b;

.is-past {
  .created-event {
    background-color: #d0d0d0 !important;
    color: #323232 !important;
    border: 2px solid #fff;
  }
}
.created-event {
  width: 99% !important;
  background-color: #030ba6 !important;
  border: 2px solid #fff;
}

.details-card {
  display: flex;
  flex-direction: column;
  width: 100px;
  height: 100%;
  button {
    margin: 0;
    border: none;
    color: white;
    position: absolute;
    padding-right: 0px;
    top: 0px;
    right: 0px;
    cursor: pointer;
    background: transparent;
    svg {
      width: 18px;
      height: 18px;
      fill: white;
    }
  }
  .remove {
    opacity: 0;
    transition: opacity 0.15s;
  }
  &:hover .remove {
    opacity: 1;
  }
}
.popup-event .buttons {
  display: flex;
  justify-content: space-between;
}
.popup-event .buttons button {
  border: none;
  color: #29771c;
  background-color: rgba($green, 0.04);
  padding: 5px 10px;
  &.cancel {
    background-color: rgba($red, 0.04);
    color: $red;
  }
}
.show-slots .vue-portal-target {
  outline: dashed 1px red;
  outline-offset: -1px;
}

.kalendar-wrapper {
  min-height: 0px !important;
}
</style>



// WEBPACK FOOTER //
// CalendarUser.vue?ee5b3f0c